import React from 'react';
import { useCustomComponent } from '@/hooks';
import { Icon } from '../../ui';

const SubmitIcon: React.FC<{ color: string }> = ({ color }) => (
  <div className="-rotate-45">
    <Icon name="PaperAirplane" color={color} height={12} width={12} />
  </div>
);

export const SubmitIconComponent: React.FC<{ color: string }> = ({ color }) => {
  const Component = useCustomComponent({
    componentName: 'QuestionnaireSubmitIcon',
    Component: (p: { color: string }) => <SubmitIcon {...p} />,
  });
  return <Component color={color} />;
};
